<template>
  <div id="body-fat-index">
    <form
       @submit.prevent="calculate"
    >
      <div>
        <select v-model="gender" id="gender">
          <option value="">Płeć</option>
          <option value="m">Mężczyzna</option>
          <option value="k">Kobieta</option>
        </select>
      </div>
      <div>
        <input type="number" min="0" v-model="waist" placeholder="Obwód talii (cm)" required="required">
      </div>
      <div>
        <input type="number" min="0" v-model="hip" :disabled="gender == 'm'" placeholder="Obwód bioder (cm)" required="required">
      </div>
      <div>
        <input type="number" min="0" v-model="neck" placeholder="Obwód szyi (cm)" required="required">
      </div>
      <div>
        <input type="number" min="0" v-model="weight" placeholder="Waga (kg)" required="required">
      </div>
      <div>
        <input type="number" min="0" v-model="height" placeholder="Wzrost (cm)" required="required">
      </div>
      <div>
        <input type="submit" value="Przelicz">
      </div>
    </form>
    <div class="result" v-if="showResult">
      Your body fat level:
      {{this.result}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'BodyFatIndex',
  methods: {
    calculate: function() {
      if ( this.gender === 'm' ) {
				this.result = 495 / ( 1.0324 - 0.19077 * Math.log10(Number(this.weight) - Number(this.neck)) + 0.15456 * Math.log10(Number(this.height)) ) - 450;
			}
			else if ( this.gender === 'k' ) {
				this.result = 495 / ( 1.29579 - 0.35004 * Math.log10(Number(this.waist) + Number(this.hip) - Number(this.neck)) + 0.22100 * Math.log10(Number(this.height)) ) - 450;
			}

      this.result = this.result.toFixed(0) + '%';
      this.showResult = true;
    }
  },
  data() {
    return {
      gender: '',
      waist: null,
      hip: null,
      neck: null,
      weight: null,
      height: null,
      result: 0,
      showResult: false
    }
  }
}
</script>

